import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CheckCircle, Clock, Loader2, Mail, XCircle } from "lucide-react";
import { useState } from "react";
import type { HistoricalResult } from "./settings-types";

// ============================================================
// Historical Email Pull — Import older emails
// ============================================================

export function HistoricalPullCard() {
	const [days, setDays] = useState(180);
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: () =>
			api.post<{ data: HistoricalResult }>(
				"/settings/sync/emails/historical",
				{ days },
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["sync-status"] });
			queryClient.invalidateQueries({ queryKey: ["emails"] });
			queryClient.invalidateQueries({ queryKey: ["email-stats"] });
		},
	});

	return (
		<div className="card space-y-3">
			<div className="flex items-center gap-2">
				<Clock size={18} className="text-amber-600" />
				<span className="font-medium text-stone-800">
					Historische E-Mails importieren
				</span>
			</div>
			<p className="text-xs text-stone-500">
				Importiert ältere E-Mails aus Gmail. Bereits verarbeitete Nachrichten
				werden übersprungen.
			</p>
			<div className="flex items-end gap-3">
				<div>
					<label
						htmlFor="hist-days"
						className="text-xs font-medium text-stone-500 block mb-1"
					>
						Zeitraum (Tage)
					</label>
					<input
						id="hist-days"
						type="number"
						min={1}
						max={365}
						value={days}
						onChange={(e) => setDays(Number(e.target.value))}
						className="input w-24"
					/>
				</div>
				<button
					type="button"
					disabled={mutation.isPending || days < 1 || days > 365}
					onClick={() => mutation.mutate()}
					className="btn-primary !py-2 !px-4 text-xs"
				>
					{mutation.isPending ? (
						<Loader2 size={12} className="animate-spin inline mr-1" />
					) : (
						<Mail size={12} className="inline mr-1" />
					)}
					{mutation.isPending ? "Importiere..." : "Importieren"}
				</button>
			</div>

			{mutation.isSuccess && (
				<p className="text-xs text-green-600 flex items-center gap-1">
					<CheckCircle size={12} />
					{mutation.data.data.message}
				</p>
			)}
			{mutation.isError && (
				<p className="text-xs text-red-600 flex items-center gap-1">
					<XCircle size={12} />
					{mutation.error instanceof Error
						? mutation.error.message
						: "Import fehlgeschlagen"}
				</p>
			)}
		</div>
	);
}
